import axiosInstance from '../../../lib/axios';
import { CASES_API_URL } from '../../../config/env';

export const getCases = async ({ page = 1, limit = 20, species, caseType, postType, q } = {}) => {
  const speciesParam = Array.isArray(species)
    ? species.filter(s => s !== 'All').map(s => s.toLowerCase()).join(',')
    : species === 'All' ? undefined : species;

  const response = await axiosInstance.get(CASES_API_URL, {
    params: { page, limit, species: speciesParam || undefined, caseType, postType: postType || undefined, q: q || undefined },
  });
  return response.data;
};


export const likeCase = async (caseId) => {
  const response = await axiosInstance.post(`${CASES_API_URL}/${caseId}/like`);
  return response.data;
};

export const getCase = async (caseId) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/${caseId}`);
  return response.data;
};

export const addClinicalInput = async ({ caseId, content, parentId }) => {
  const response = await axiosInstance.post(`${CASES_API_URL}/${caseId}/clinical-inputs`, { content, parentId });
  return response.data;
};

export const getClinicalInputs = async (caseId) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/${caseId}/clinical-inputs`);
  return response.data;
};

export const editClinicalInput = async ({ inputId, content }) => {
  const response = await axiosInstance.put(`${CASES_API_URL}/clinical-inputs/${inputId}`, { content });
  return response.data;
};

export const deleteClinicalInput = async (inputId) => {
  const response = await axiosInstance.delete(`${CASES_API_URL}/clinical-inputs/${inputId}`);
  return response.data;
};

export const likeClinicalInput = async (inputId) => {
  const response = await axiosInstance.post(`${CASES_API_URL}/clinical-inputs/${inputId}/like`);
  return response.data;
};

export const createCase = async (caseData) => {
  const response = await axiosInstance.post(CASES_API_URL, caseData);
  return response.data;
};

export const updateCase = async ({ caseId, data, ...caseData }) => {
  const payload = data ? { ...data, ...caseData } : caseData;
  const response = await axiosInstance.patch(`${CASES_API_URL}/${caseId}`, payload);
  return response.data;
};

export const saveCase = async (caseId) => {
  const response = await axiosInstance.post(`${CASES_API_URL}/${caseId}/save`);
  return response.data;
};

export const deleteCase = async (caseId) => {
  const response = await axiosInstance.delete(`${CASES_API_URL}/${caseId}`);
  return response.data;
};

export const getSavedCases = async ({ page = 1, limit = 20 } = {}) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/saved`, {
    params: { page, limit },
  });
  return response.data;
};

export const getMyCases = async ({ page = 1, limit = 20 } = {}) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/my-cases`, {
    params: { page, limit },
  });
  return response.data;
};

export const getMyInputs = async ({ page = 1, limit = 20 } = {}) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/my-inputs`, {
    params: { page, limit },
  });
  return response.data;
};

export const getStudentStats = async () => {
  const response = await axiosInstance.get(`${CASES_API_URL}/student-stats`);
  return response.data;
};

// Access Requests
export const requestCaseAccess = async ({ caseId, reason }) => {
  const response = await axiosInstance.post(`${CASES_API_URL}/${caseId}/access-requests`, { reason });
  return response.data;
};

export const getCaseAccessRequests = async (caseId) => {
  const response = await axiosInstance.get(`${CASES_API_URL}/${caseId}/access-requests`);
  return response.data;
};

export const updateAccessRequestStatus = async ({ requestId, status }) => {
  const response = await axiosInstance.patch(`${CASES_API_URL}/access-requests/${requestId}`, { status });
  return response.data;
};

// Notifications
export const getMyNotifications = async () => {
  const response = await axiosInstance.get(`/api/notifications`);
  return response.data;
};

export const getUnreadNotificationCount = async () => {
  const response = await axiosInstance.get(`/api/notifications/unread-count`);
  return response.data;
};

export const markNotificationAsRead = async (notificationId) => {
  const response = await axiosInstance.patch(`/api/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await axiosInstance.patch(`/api/notifications/read-all`);
  return response.data;
};

/**
 * Request a presigned PUT URL for a document (PDF / DOC / DOCX).
 * The browser uploads directly to B2 using the returned uploadUrl.
 * The key is submitted with the case payload on post/edit.
 */
export const presignDocumentUpload = async ({ filename, contentType, size }) => {
  let resolvedType = contentType;
  if (!resolvedType) {
    const ext = filename?.split('.').pop()?.toLowerCase();
    if (ext === 'pdf') resolvedType = 'application/pdf';
    else if (ext === 'doc') resolvedType = 'application/msword';
    else if (ext === 'docx') resolvedType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }

  const response = await axiosInstance.post(`${CASES_API_URL}/media/document/presign`, {
    filename,
    contentType: resolvedType,
    size,
  });
  return response.data;
};